import marker from 'images/pin.png';

export const MARKER_OPTIONS = {
  iconLayout: 'default#image',
  iconImageHref: marker,
  iconImageSize: [60, 60],
  iconImageOffset: [-30, -60],
};

export const MAP_DEFAULT_ZOOM = 16;
